import {
  difficultiesByGameVersion,
  defaultDifficultyByGameVersion,
} from 'app/frontend/types/custom/Difficulty'
import { usePageInfo } from 'app/frontend/base/config/queries'

export const useDifficulties = () => {
  const {
    data: { gameVersion },
  } = usePageInfo()
  return {
    difficulties: difficultiesByGameVersion[gameVersion],
    defaultDifficulty: defaultDifficultyByGameVersion[gameVersion],
  }
}
